import axios from "axios";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  post: (url, payload, headers = {}) => {
    return axios.post(url, payload, { headers });
  },
};
